import React from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/Button';
import { Check, Award, Users, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
export function About() {
  return <Layout data-id="element-109">
      {/* Hero Section */}
      <section className="relative py-32 px-4 bg-gradient-to-br from-taupe-200/50 to-cream-100 border-b border-taupe-200" data-id="element-110">
        <div className="max-w-4xl mx-auto text-center" data-id="element-111">
          <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-6 block" data-id="element-112">
            Our Story
          </span>
          <h1 className="text-4xl md:text-6xl font-serif text-charcoal-900 mb-6 leading-tight" data-id="element-113">
            Creating Beautiful Spaces
            <br data-id="element-114" />
            <span className="italic" data-id="element-115">for Over Two Decades</span>
          </h1>
          <p className="text-xl text-charcoal-900/70 leading-relaxed max-w-2xl mx-auto" data-id="element-116">
            Down Home Interiors has been Howell's trusted partner for interior
            design, home décor, and staging since 2003.
          </p>
        </div>
      </section>

      {/* About the Owner - Denise Down */}
      <section className="py-24 px-4 bg-white" data-id="element-117">
        <div className="max-w-6xl mx-auto" data-id="element-118">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-119">
            <div className="aspect-[3/4] bg-taupe-300 flex items-center justify-center text-charcoal-900/20 font-serif text-xl" data-id="element-120">
              [Denise Down Photo]
            </div>
            <div data-id="element-121">
              <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-4 block" data-id="element-122">
                Meet the Owner
              </span>
              <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-123">
                Denise Down
              </h2>
              <p className="text-lg text-charcoal-900/70 leading-relaxed mb-6" data-id="element-124">
                With over 20 years of experience transforming homes throughout
                Michigan, Denise Down has built Down Home Interiors on a
                foundation of personalized service and timeless design
                principles. Her hands-on approach ensures every project receives
                the attention to detail it deserves.
              </p>
              <p className="text-lg text-charcoal-900/70 leading-relaxed mb-6" data-id="element-125">
                Denise's philosophy is simple: great design should enhance how
                you live, not dictate it. She takes the time to understand each
                client's lifestyle, preferences, and goals before creating
                spaces that are both beautiful and functional.
              </p>
              <p className="text-lg text-charcoal-900/70 leading-relaxed mb-8" data-id="element-126">
                From initial consultation through final installation, Denise is
                personally involved in every project, bringing her expertise in
                space planning, color theory, and furniture selection to create
                interiors that stand the test of time.
              </p>
              <div className="flex items-center gap-4 text-sm text-charcoal-900/60" data-id="element-127">
                <div className="flex items-center gap-2" data-id="element-128">
                  <Award className="text-sage-500" size={18} data-id="element-129" />
                  <span data-id="element-130">20+ Years Experience</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-131">
                  <Users className="text-sage-500" size={18} data-id="element-132" />
                  <span data-id="element-133">500+ Projects</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What We Do */}
      <section className="py-24 px-4 bg-cream-100" data-id="element-134">
        <div className="max-w-6xl mx-auto" data-id="element-135">
          <div className="text-center mb-16" data-id="element-136">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-137">
              What We Do
            </h2>
            <p className="text-lg text-charcoal-900/60 max-w-2xl mx-auto" data-id="element-138">
              Comprehensive design services and curated retail offerings
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-139">
            {[{
            title: 'Interior Design',
            description: 'Full-service design from concept to completion. We handle space planning, color selection, furniture sourcing, and installation to create cohesive, livable spaces that reflect your personal style.'
          }, {
            title: 'Retail Home Décor',
            description: 'Our showroom features a carefully curated collection of furniture, accessories, lighting, and textiles. From statement pieces to finishing touches, find everything you need to complete your space.'
          }, {
            title: 'Real Estate Staging',
            description: 'Professional staging services that help homes sell faster and for more. We know what buyers want to see and how to present your property in its best light.'
          }, {
            title: 'Window Treatments',
            description: 'Custom drapery, blinds, and shades designed to enhance your windows while providing privacy and light control. We handle measuring, fabrication, and professional installation.'
          }, {
            title: 'Custom Furnishings',
            description: "Can't find exactly what you're looking for? We work with trusted craftspeople to create custom furniture and upholstery pieces tailored to your specifications."
          }, {
            title: 'Design Consultations',
            description: 'Not ready for a full project? Our hourly consultation service provides expert guidance on color, layout, and styling to help you make confident design decisions.'
          }].map((service, index) => <div key={index} className="bg-white p-8 border border-taupe-200 shadow-card" data-id="element-140">
                <h3 className="text-xl font-serif text-charcoal-900 mb-4" data-id="element-141">
                  {service.title}
                </h3>
                <p className="text-charcoal-900/70 leading-relaxed" data-id="element-142">
                  {service.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Why Clients Choose Us */}
      <section className="py-24 px-4 bg-white" data-id="element-143">
        <div className="max-w-5xl mx-auto" data-id="element-144">
          <div className="text-center mb-16" data-id="element-145">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-146">
              Why Clients Choose Down Home Interiors
            </h2>
            <p className="text-lg text-charcoal-900/60" data-id="element-147">
              What sets us apart in the world of interior design
            </p>
          </div>

          <div className="space-y-8" data-id="element-148">
            {[{
            icon: <Heart className="text-sage-500" size={24} data-id="element-149" />,
            title: 'Personalized Attention',
            description: "Every project receives hands-on involvement from Denise Down herself. We don't believe in cookie-cutter solutions—your home should be as unique as you are."
          }, {
            icon: <Award className="text-sage-500" size={24} data-id="element-150" />,
            title: 'Two Decades of Expertise',
            description: 'With over 20 years serving the Howell community, we bring deep knowledge of design principles, local resources, and proven processes that ensure successful outcomes.'
          }, {
            icon: <Check className="text-sage-500" size={24} data-id="element-151" />,
            title: 'Full-Service Convenience',
            description: 'From design to installation, we handle every detail. Our relationships with trusted contractors and craftspeople mean seamless execution from start to finish.'
          }, {
            icon: <Users className="text-sage-500" size={24} data-id="element-152" />,
            title: 'Local Showroom',
            description: 'See and touch materials before you commit. Our retail location offers a curated selection of furnishings and décor, plus the ability to special order from our extensive vendor network.'
          }, {
            icon: <Heart className="text-sage-500" size={24} data-id="element-153" />,
            title: 'Timeless Design Philosophy',
            description: 'We create interiors that age gracefully. While we stay current with trends, our focus is on classic design principles that ensure your space looks beautiful for years to come.'
          }].map((point, index) => <div key={index} className="flex gap-6 items-start" data-id="element-154">
                <div className="flex-shrink-0 w-12 h-12 bg-sage-100 rounded-full flex items-center justify-center" data-id="element-155">
                  {point.icon}
                </div>
                <div data-id="element-156">
                  <h3 className="text-xl font-serif text-charcoal-900 mb-2" data-id="element-157">
                    {point.title}
                  </h3>
                  <p className="text-charcoal-900/70 leading-relaxed" data-id="element-158">
                    {point.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-4 bg-gradient-to-br from-taupe-200/50 to-cream-100" data-id="element-159">
        <div className="max-w-4xl mx-auto text-center" data-id="element-160">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-161">
            Ready to Start Your Project?
          </h2>
          <p className="text-xl text-charcoal-900/70 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-162">
            Visit our showroom to explore our collections or schedule a
            consultation to discuss your design needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-163">
            <Link to="/store-info" data-id="element-164">
              <Button size="lg" className="min-w-[200px]" data-id="element-165">
                Visit the Store
              </Button>
            </Link>
            <Link to="/contact" data-id="element-166">
              <Button variant="outline" size="lg" className="min-w-[200px]" data-id="element-167">
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>;
}